<template>
  <i v-if="flagIconClassName" class="wd-mr-2" :class="flagIconClassName" :style="{ fontSize: `${size}px` }"></i>
</template>

<script lang="ts">
import { phoneHelpers } from '@/utils/phone'

export default defineComponent({
  props: {
    /** 電話國碼 ex: +886 */
    callingCode: { type: String },
    /** 國家代碼 ex: TW */
    countryCode: { type: String },
    size: { type: Number, default: 16 },
  },
  setup(props) {
    const flagIconClassName = computed(() => {
      const code = props.countryCode || (props.callingCode ? phoneHelpers.getRegionCodeForCountryCode(Number(props.callingCode)) : '')

      return code ? `fi fi-${code.toLocaleLowerCase()}` : ''
    })

    return {
      flagIconClassName,
    }
  },
})
</script>

<style lang="scss">
.fi {
  box-shadow: unset;
}
</style>
